import React from 'react';

const LogoutSuccessSVG = () => (
  <svg
    width="125"
    height="125"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="13" cy="13" r="9" className="logout-success-svg" />
    <path
      d="M16.4525 9L11.75 13.82L9.54667 11.7317L8 13.28L11.75 16.9167L18 10.5475L16.4525 9Z"
      fill="white"
    />
  </svg>
);

export { LogoutSuccessSVG };
